import React from "react";

const ArrowRight = ({ size = 4, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="20 50.001 159.999 99.999"
      width={size * 4}
      height={size * 4}
    >
      <g clipPath="url(#_clipPath_tfHD4JfK2XkmV5Y2LDQpR4XEH5BhKjm5)">
        <path
          d=" M 142.529 25.268 C 150.741 33.241 150.997 46.542 143.096 54.824 L 99.999 100.001 L 144.799 143.491 C 153.011 151.464 153.267 164.765 145.366 173.047 C 137.466 181.329 124.28 181.582 116.067 173.609 L 56.336 115.623 C 48.123 107.65 47.868 94.349 55.769 86.067 L 113.231 25.831 C 121.132 17.548 134.315 17.295 142.529 25.268 Z "
          fill={color}
        />
      </g>
    </svg>
  );
};

export default ArrowRight;
